import { RefObject, useEffect, useRef, useState } from "react";

/**
 * プロジェクト詳細(PC)画面右部の定量情報&ボタンエリアが、
 * 下までスクロールした際にフッターを超えてしまわないようにするための措置。
 * ウィンドウの縦幅が短いと再現する。
 * `isScrolledByBottom`がtrueの場合に所定のスタイルを付与することで解決している。
 * TODO: 多分sticky使えば解決するかも？
 */
export const useScrollLimitation = (): [
  RefObject<HTMLDivElement>,
  RefObject<HTMLDivElement>,
  boolean
] => {
  const wrapFooterElement = useRef<HTMLDivElement>(null);
  const detailContentLinkElement = useRef<HTMLDivElement>(null);
  const [isScrolledByBottom, setIsScrolledByBottom] = useState(false);
  useEffect(() => {
    const handleScroll = (): void => {
      const windowHeight = window.innerHeight;
      const scrollHeight = window.document.body.offsetHeight;
      const scrollPosition = window.innerHeight + window.pageYOffset;
      const footHeight = wrapFooterElement.current?.offsetHeight || 0;
      const fixedHeight = detailContentLinkElement.current?.offsetHeight || 0;
      const contentTopPos = detailContentLinkElement.current?.offsetTop || 0;
      if (windowHeight <= footHeight + fixedHeight + contentTopPos) {
        const result = scrollHeight - scrollPosition <= footHeight;
        setIsScrolledByBottom(result);
      }
    };
    window.addEventListener("scroll", handleScroll, true);
    return (): void => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return [wrapFooterElement, detailContentLinkElement, isScrolledByBottom];
};
